import * as React from "react";

import { useMediaQuery, useTheme } from "@mui/material";

import { CentredTemplateDesktop } from "./CentredTemplateDesktop";
import { CentredTemplateMobile } from "./CentredTemplateMobile";
import { PageHeaderWithSignin } from "@/components/organisms/PageHeaderWithSignin";
import { PageHeaderWithSignup } from "@/components/organisms/PageHeaderWithSignup";
import { PageHeader } from "@/components/organisms/PageHeader";
import { PageHeaderWithSignout } from "@/components/organisms/PageHeaderWithSignout";

export type CentredTemplateProps = {
  sx?: React.CSSProperties;
  headerType: HeaderType;
  errorMessage?: string;
  busy?: boolean;
  children: React.ReactNode;
  removeErrorMessage?: () => void;
};

type HeaderType = "signin" | "signup" | "signout" | "logo";

export const CentredTemplate: React.FC<CentredTemplateProps> = ({
  sx,
  headerType,
  busy,
  errorMessage,
  children,
  removeErrorMessage,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  if (matches) {
    return (
      <CentredTemplateMobile
        sx={sx}
        busy={busy}
        errorMessage={errorMessage}
        header={mobileHeader(headerType)}
        removeErrorMessage={removeErrorMessage}
      >
        {children}
      </CentredTemplateMobile>
    );
  }

  return (
    <CentredTemplateDesktop
      sx={sx}
      busy={busy}
      errorMessage={errorMessage}
      header={desktopHeader(headerType)}
      removeErrorMessage={removeErrorMessage}
    >
      {children}
    </CentredTemplateDesktop>
  );
};

const mobileHeader = (headerType?: HeaderType) => header(headerType, false);

const desktopHeader = (headerType?: HeaderType) => header(headerType, true);

const header = (headerType: HeaderType | undefined, includeHeader: boolean) => {
  switch (headerType) {
    case "signin":
      return <PageHeaderWithSignin includeLogo={includeHeader} />;
    case "signout":
      return <PageHeaderWithSignout includeLogo={true} />;
    case "signup":
      return <PageHeaderWithSignup includeLogo={includeHeader} />;
    default:
      return <PageHeader includeLogo={includeHeader} />;
  }
};
